import { ReferralStatusIndicator } from '@strata/react-status-indicators';

export const isReferralRowDisabled = (status) =>
    [ReferralStatusIndicator.Statuses.CANCELLED].includes(status?.trim());
